import { webBuilderRequest } from './api.utils';
import { WebsiteType } from '../../types/website.types';

const getRequestPath = (websiteType: WebsiteType): { initPath: string; endPath: string } => ({
  initPath: websiteType === 'theme' ? 'admin' : 'client',
  endPath: websiteType === 'theme' ? 'theme-assets' : 'website-assets',
});

export const fetchAssets = async (websiteType: WebsiteType): Promise<{ id: string; url: string }[]> => {
  const { initPath, endPath } = getRequestPath(websiteType);
  return webBuilderRequest(`${initPath}/v1/${endPath}`, { method: 'GET' });
};

export const deleteAsset = async (assetId: string, websiteType: WebsiteType): Promise<void> => {
  const { initPath, endPath } = getRequestPath(websiteType);
  return webBuilderRequest(`${initPath}/v1/${endPath}/${assetId}`, { method: 'DELETE' });
};
export const getFileType = (url: string): string => {
  const extension = url.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'mp4':
    case 'm4v':
    case 'webm':
    case 'ogg':
    case 'avi':
    case 'mov':
      return 'video';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
    case 'svg':
      return 'image';
    default:
      return 'image';
  }
};

export const getFileName = (url: string): string => {
  return url.split('/').pop() || url;
};

export const uploadAsset = async (file: File, websiteType: WebsiteType): Promise<{ id: string; url: string }> => {
  let asset = null;
  const { initPath, endPath } = getRequestPath(websiteType);
  asset = await webBuilderRequest(`${initPath}/v1/${endPath}`, {
    method: 'PUT',
    body: { mime: file.type },
  });
  await fetch(asset.uploadUrl, { method: 'PUT', body: file });
  const completeAsset = await webBuilderRequest(`${initPath}/v1/${endPath}/${asset.id}/complete`, {
    method: 'POST',
    body: null,
  });
  return completeAsset;
};
